import { request } from '../../helpers/api/request';
import { NotificationContract } from '../../types/Endpoints/notification/NotificationContract';

export const getNotifications = async () => {
    const { data } = await request<NotificationContract>({
        url: 'notifications/list/',
    });

    return data;
};
